<script>
import SubstanceV4 from '@/views/product/components/product-card/composition/SubstanceV4.vue'
import CandidateListStructured from './CandidateListStructured.vue'

export default {
    name: 'SubstanceEditorStructured',
    extends: SubstanceV4,
    components: {
        CandidateListStructured,
    },
    computed: {
        substanceIdentity() {
            return this.substance.substance || {}
        },
        hasCas() {
            return this.substanceIdentity.cas && this.substanceIdentity.cas !== '-'
        },
        hasEc() {
            return this.substanceIdentity.ec && this.substanceIdentity.ec !== '-'
        },
    },
}
</script>

<template>
    <Overlay :show="showLoading">
        <b-card
            no-body
            class="substance-editor-structured"
        >
            <header class="substance-editor-structured__header">
                <div class="substance-editor-structured__identity">
                    <h5 class="mb-50">
                        {{ substanceIdentity.title }}
                    </h5>
                    <div
                        v-if="hasCas || hasEc"
                        class="substance-editor-structured__identifiers"
                    >
                        <span v-if="hasCas">CAS {{ substanceIdentity.cas }}</span>
                        <span v-if="hasEc">EC {{ substanceIdentity.ec }}</span>
                    </div>
                </div>
                <b-button
                    variant="outline-danger"
                    class="btn-icon flex-shrink-0"
                    size="sm"
                    :title="$t('Component(Button):remove')"
                    :aria-label="$t('Component(Button):remove')"
                    @click="exclude"
                >
                    <feather-icon icon="Trash2Icon" />
                </b-button>
            </header>

            <div
                v-if="hasPropertiesToRender"
                class="substance-editor-structured__body"
            >
                <div
                    v-if="commonProperties.length > 0"
                    class="substance-editor-structured__common-fields"
                >
                    <b-row>
                        <b-col
                            v-for="property in commonProperties"
                            :key="property.type"
                            cols="12"
                            lg="6"
                        >
                            <component
                                :is="property.name"
                                :read-only="readOnly"
                                :compact-view="compactView"
                                :config="property"
                                :value="propertyValue(property)"
                                @input="value => change(property, value)"
                            />
                        </b-col>
                    </b-row>
                </div>

                <section
                    v-if="isCandidateListActive"
                    class="substance-editor-structured__list-section"
                >
                    <div class="substance-editor-structured__list-heading">
                        {{ candidateListTitle }}
                    </div>
                    <CandidateListStructured
                        :candidate-list="candidateList"
                        :compact-view="compactView"
                        :read-only="readOnly"
                        :values="productProperties"
                        :properties="propsConfig.properties"
                        :substance="substanceIdentity"
                        @input="candidateListChange"
                    />
                </section>

                <section
                    v-for="listProps in listProperties"
                    :key="listProps.list.id"
                    class="substance-editor-structured__list-section"
                >
                    <div class="substance-editor-structured__list-heading">
                        {{ listProps.list.title }}
                    </div>
                    <b-row>
                        <b-col
                            v-for="property in listProps.properties"
                            :key="property.type"
                            cols="12"
                            lg="6"
                        >
                            <component
                                :is="property.name"
                                :read-only="readOnly"
                                :compact-view="compactView"
                                :list="listProps.list"
                                :substance="substanceIdentity"
                                :config="property"
                                :value="propertyValue(property, listProps.list)"
                                @input="value => change(property, value, listProps.list)"
                            />
                        </b-col>
                    </b-row>
                </section>
            </div>
        </b-card>
    </Overlay>
</template>

<style lang="scss">
.substance-editor-structured {
    overflow: visible;

    &__header {
        align-items: flex-start;
        background: #fff;
        border-bottom: 1px solid #ebe9f1;
        display: flex;
        gap: 1rem;
        justify-content: space-between;
        padding: 1rem 1.25rem;
    }

    &__identity {
        min-width: 0;
    }

    &__identifiers {
        color: #6e6b7b;
        display: flex;
        flex-wrap: wrap;
        font-size: .875rem;
        gap: .35rem 1rem;
    }

    &__body {
        padding: 1.25rem;
    }

    &__common-fields {
        max-width: 68rem;
    }

    &__list-section {
        border-left: 3px solid #f58049;
        max-width: 68rem;
        padding: .25rem 0 0 1rem;

        & + & {
            border-top: 1px solid #ebe9f1;
            margin-top: 1.25rem;
            padding-top: 1.25rem;
        }
    }

    &__list-heading {
        color: #5e5873;
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 1rem;
    }

    .form-group {
        margin-bottom: 1rem;
    }

    .input-bg-warning {
        background-color: #fff !important;
    }

    .treeselect-bg-warning .vue-treeselect__control {
        background-color: #fff !important;
    }
}
</style>
